<template>
  <Banner v-if="Object.keys(bannerData).length" :data="bannerData" />
  <div class="py-16 px-4 xl:px-0 bg-[#f7ecdf]">
    <OccasionsCategoriesSection v-if="Object.keys(categoriesData).length" :data="categoriesData" />
  </div>
</template>

<script setup lang="ts">
import { ref, watchEffect } from 'vue'
import { useHead } from '@vueuse/head'
import Banner from '@/components/modules/howitworks/Banner.vue'
import { useDynamicTranslations } from '@/i18n'
import OccasionsCategoriesSection from '@/components/modules/occasions/OccasionsCategoriesSection.vue'
import { occasionsMeta } from '@/config/meta'

const bannerData = ref({})
const categoriesData = ref({})
const faqData = ref({})
const { loadData } = useDynamicTranslations()

// Set meta tags for the occasions page
useHead(occasionsMeta)

// Automatically load data for the current language and update on language change
watchEffect(async () => {
  bannerData.value = await loadData('occasionsBanner')
  categoriesData.value = await loadData('occasionsCategories')
})
</script>
